import authenticationSaga from '../components/authentication/sagas';
import flightRequestSaga from '../components/FlightRequest/sagas';
import apiSagas from '../dataProvider/sagas';
import agentSagas from '../components/agent/sagas';
import rulesSagas from '../components/Rules/sagas';
import reportSagas from '../components/FlightReport/sagas';
import flightRequestReportSagas from '../components/FlightRequestReport/sagas';
import flightRequestOfferSagas from '../components/FlightRequestOffer/sagas';
import flightRequestsListSagas from '../components/FlightRequestList/sagas';
import rplSagas from '../components/Rpl/sagas';
import securitySagas from '../components/security/sagas';
//import cancellationSagas from '../components/FlightCancellation/sagas';

const sagas = [authenticationSaga, flightRequestSaga, apiSagas, agentSagas, rulesSagas, reportSagas, flightRequestReportSagas, flightRequestOfferSagas, flightRequestsListSagas, rplSagas, securitySagas];

export default sagas;
